// @flow
import React from 'react';
import { withAbsolute } from '@graphite/abs-grid';
import { useSelector } from '@graphite/use-redux';
import { getWidgets } from '@graphite/selectors';
import { composeCached } from 'Widget/selectors';
import { presetWidgets } from '@graphite/constants';
import Text, { type TProps } from '@graphite/widget-text';
import emptyObject from 'empty/object';
import type { TWidgetOwnProps, TPositionValue } from '@graphite/types';

import withHydrate from '../../libs/with-hydrate';

type TPropsParent = $ReadOnly<{|
	...$Exact<TProps>,
	position: TPositionValue,
|}>;

const TextWithDecorators = withAbsolute<TPropsParent>()(
	withHydrate<TPropsParent>(Text, {
		baseSx: {
			flexDirection: 'column',
		},
	}),
);
const TextWithProps = ({
	id,
	containerId,
	gridspec,
	widgetspec,
	colorspec,
	effectspec,
}: TWidgetOwnProps) => {
	const widgets = useSelector(getWidgets);

	if (!containerId) return null;
	if (!gridspec) return null;
	if (!widgetspec) return null;
	if (!colorspec) return null;
	if (!effectspec) return null;

	const data = composeCached(
		widgets,
		// Fixme: Подправить после выкатки шаблонов
		widgets[id] || presetWidgets[id],
	);

	const parent = composeCached(
		widgets,
		// Fixme: Подправить после выкатки шаблонов
		widgets[containerId] || presetWidgets[containerId],
	);
	const positions = parent ? parent.positions : emptyObject;

	return (
		<TextWithDecorators
			data={data}
			widgetspec={widgetspec}
			colorspec={colorspec}
			gridspec={gridspec}
			effectspec={effectspec}
			position={positions[data._id]}
		/>
	);
};

export default TextWithProps;
